import { UI, VStack } from '@genial/components';
import React from 'react';

export const SubscriptionCustomerEmptyList: React.FC = () => {
  return (
    <VStack py="stack.huge">
      <UI.ErrorBoundary
        errorIconOrIllustration="NotEmptyIllustration"
        errorTitle="Nenhum cliente disponível"
        errorMessage="No momento, não há clientes disponíveis para subscrição."
      />
    </VStack>
  );
};
